



































import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GConfirmationModal',
  props: {
    texts: { type: Array as PropType<string[]>, required: true },
    onClose: { type: Function as PropType<() => void>, default: null },
    onConfirmed: { type: Function as PropType<() => void>, required: true },
    onDenied: { type: Function as PropType<() => void>, required: true },
  },
});
